import { render } from "./DocumentInfoPieGraph.vue?vue&type=template&id=4689d1d0&ts=true"
import script from "./DocumentInfoPieGraph.vue?vue&type=script&lang=ts"
export * from "./DocumentInfoPieGraph.vue?vue&type=script&lang=ts"

import "./DocumentInfoPieGraph.vue?vue&type=style&index=0&id=4689d1d0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__